module.exports = __webpack_public_path__ + "img/user-logo.8fbea55d.jpg";